module.exports = __webpack_public_path__ + "media/images/emblems/Orzens-coat_of_arms-8361997e1bee42937ca08d25cd264a9b.svg";